import moment from "moment";

export function formatDate(dateString: string|null, format?: string) {
    if(typeof dateString !== 'string') {
        return '';
    }
    return (moment(Date.parse(dateString))).format(format ?? 'DD/MM/YYYY HH:mm');
}

export function timeAgo(dateString: string|null) {
    if(typeof dateString !== 'string') {
        return '';
    }
    return (moment(Date.parse(dateString))).fromNow();
}

export function niceDate(dateString: string|null) {
    if(typeof dateString !== 'string') {
        return '';
    }
    return (moment(Date.parse(dateString))).format('Do MMMM YYYY h:mma');
}
